import { useCaseScopedCapability } from './active-practice.tsx';
import { useCaseRead } from './use-case-read.ts';
import { usePersona } from './use-persona.ts';

/**
 * May the viewer read this case's payers (`payer.list`, `case.read_payers`)? The case menu's
 * Invoicing item and the Invoicing screen's payer read both ask here. The screen asked the
 * server first, so a client opening an invoice alert was refused and audited every time (TF-0033).
 * The biller holds no case row, so billing authority in the case's practice also answers yes.
 */
export function useCanReadCasePayers(caseId: string | null): boolean {
  const { canManageBillingAnywhere } = usePersona();
  const { caseQ } = useCaseRead(caseId, { businessFallback: canManageBillingAnywhere });
  const businessAuthorityCanBill = useCaseScopedCapability('case.manage_billing');
  return (caseQ.data?.case?.myCapabilities ?? []).includes('case.read_payers') || businessAuthorityCanBill;
}
